import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import ContactForm from '../ContactForm';
import ContactInfoSection from '../Section/ContactInfoSection';
import { pageTitle } from '../../helpers/PageTitle';

export default function Contact() {
  pageTitle('Contact');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/new/Mental health icon 04 Self love 2.png"
        title="Contact Us"
        subTitle="Kindly reach us to get the fastest response and treatment"
      />
      {/* On large screens the form overlaps the bottom of the banner. */}
      <div className="container relative z-[5] pt-10 md:pt-16 lg:pt-0 lg:-mt-[110px]">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <ContactForm />
          </div>
        </div>
      </div>
      <ContactInfoSection sectionTitle="Find Us Here" />
    </>
  );
}
